module.exports = __webpack_public_path__ + "static/media/puzzles-social-image.f526893f.png";